import { Icon, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 24px;
  align-items: center;
  margin-left: -4px;
`;

const IconWrapper = styled.div`
  border-style: solid;
  border-width: ${(props) => (props.first ? '0' : '1px')};
  border-radius: 32px;
  border-color: ${(props) => props.col || 'white'};
  margin-right: -3px;
`;

const Reactions = ({ entity, showNoLikesNotice, col, small }) => {
  const { t } = useTranslation();

  if (!entity) return null;

  const sortedData = Object.entries(entity)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3);

  const totalLikes = Object.values(entity).reduce((a, b) => a + b);

  if (!totalLikes)
    return showNoLikesNotice ? (
      <Wrapper>
        <Text c2 med size="14px" col={theme.GREY_60}>
          {t('comments.beFirstReaction')}
        </Text>
      </Wrapper>
    ) : (
      <Wrapper />
    );

  return (
    <Wrapper>
      {sortedData.map((x, i) => {
        if (!x[1]) return null;

        return (
          <IconWrapper col={col} key={i} first={i === 0} small={small}>
            <Icon type={`${x[0]}React`} dimensions={16} />
          </IconWrapper>
        );
      })}

      <Text size="12px" bold marg="0 0 0 8px">
        {totalLikes}
      </Text>
    </Wrapper>
  );
};

export default Reactions;
